export * from "./DefaultDepartmentBehavior";
export * from "./DefaultUserBehavior";
export * from "./DoctorBehavior";
export * from "./HisInfoListItemBehavior";
export * from "./HisInfoUserGroupInputBehaviorFactory";
export * from "./IHisInfoGroupBehavior";
export * from "./UserKanaNameBehavior";
